// src/pages/Turnandre.js
import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Image,
  HStack,
  UnorderedList,
  ListItem,
  VStack,
  Link,
  Badge,
  Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';
import { EmailIcon, PhoneIcon } from '@chakra-ui/icons';
import turnandreGroup from '../images/turnandre-group.jpg';
import sanpaoloLogo from '../images/sanpaolo_logo.png';

const Turnandre = () => {
  return (
    <Box overflow="hidden" bg="#36393f" color="white" minHeight="100vh">
      {/* SEZIONE: Turnandrè */}
      <Box
        bg="#2f3136"
        borderRadius="8px"
        px={{ base: 4, md: 8 }}
        py={{ base: 10, md: 10 }}
        boxShadow="xl"
        mt={8}
        mb={8}
        border="1px solid"
        borderColor="gray.600"
      >
        <Container maxW="container.xl">
          {/* TITOLO */}
          <Box textAlign="center" mb={12}>
            <Heading as="h2" size="xl" color="white" mb={2}>
              Turnandrè
            </Heading>
            <Text fontSize="lg" color="gray.300">
              Un progetto che guarda alle radici per nutrire il futuro di una
              comunità.
            </Text>
          </Box>

          {/* 3 BOX IN RIGA */}
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} mb={12}>
            {/* BOX 1 */}
            <Box
              bg="#36393f"
              p={6}
              borderRadius="8px"
              shadow="xl"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-4px)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Heading as="h3" size="md" mb={3} color="#ffcc00">
                Dove nasce
              </Heading>
              <Text color="gray.300">
                Turnandrè – che in piemontese significa &quot;Torna
                indietro&quot; – nasce dalla volontà di un gruppo di amici e
                professionisti di ridare energia e cura a Castelnuovo Don Bosco,
                un territorio a cui sono legati da radici o da scelte affettive.
              </Text>
            </Box>

            {/* BOX 2 */}
            <Box
              bg="#36393f"
              p={6}
              borderRadius="8px"
              shadow="xl"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-4px)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Heading as="h3" size="md" mb={3} color="#ffcc00">
                Il significato
              </Heading>
              <Text color="gray.300">
                &quot;Turnandrè&quot; è un invito a osservare il territorio con
                occhi nuovi: le piazze, i silenzi, le lingue, i vicoli. È un
                cerchio che si apre alla memoria, alla riflessione, al sogno di
                ciò che sarà.
              </Text>
            </Box>

            {/* BOX 3 */}
            <Box
              bg="#36393f"
              p={6}
              borderRadius="8px"
              shadow="xl"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                transform: 'translateY(-4px)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              <Heading as="h3" size="md" mb={3} color="#ffcc00">
                Cosa vogliamo fare
              </Heading>
              <UnorderedList spacing={3} pl={4} color="gray.300">
                <ListItem>Partecipazione attiva e comunità</ListItem>
                <ListItem>Supporto psicologico accessibile</ListItem>
                <ListItem>
                  Laboratori artistici e culturali per tutte le età
                </ListItem>
                <ListItem>
                  Valorizzazione del territorio e sostenibilità
                </ListItem>
              </UnorderedList>
            </Box>
          </SimpleGrid>

          {/* TITOLO SEZIONE SERVIZI */}
          <Box textAlign="center" mb={8} mt={8}>
            <Heading as="h2" size="xl" color="white" mb={2}>
              I servizi attivi di Turnandrè
            </Heading>
            <Text fontSize="lg" color="gray.300">
              Scopri i servizi disponibili per la comunità
            </Text>
          </Box>

          {/* ACCORDION SERVIZI */}
          <Accordion allowToggle mb={12}>
            <AccordionItem
              border="2px solid"
              borderColor="#ffcc00"
              borderRadius="8px"
              mb={4}
              bg="#36393f"
              overflow="hidden"
            >
              <AccordionButton
                py={6}
                px={8}
                _hover={{ bg: '#2f3136' }}
                _expanded={{
                  bg: '#2f3136',
                  borderBottom: '1px solid',
                  borderColor: 'gray.600',
                }}
              >
                <Box flex="1" textAlign="left">
                  <Flex
                    direction={{ base: 'column', md: 'row' }}
                    align={{ base: 'flex-start', md: 'center' }}
                    justify="space-between"
                    gap={4}
                  >
                    <Heading as="h3" size="lg" color="#ffcc00">
                      Sportello di Supporto Psicologico
                    </Heading>
                    <Badge
                      colorScheme="green"
                      fontSize="md"
                      px={4}
                      py={2}
                      borderRadius="full"
                    >
                      ✓ Attivo
                    </Badge>
                  </Flex>
                </Box>
                <AccordionIcon color="#ffcc00" fontSize="2xl" />
              </AccordionButton>
              <AccordionPanel pb={8} px={8} bg="#36393f">
                <VStack spacing={6} align="stretch">
                  {/* Descrizione */}
                  <Box>
                    <Text
                      color="gray.300"
                      fontSize="lg"
                      mb={4}
                      lineHeight="tall"
                    >
                      È attivo lo sportello di supporto psicologico a prezzi
                      accessibili del progetto Turnandrè.
                    </Text>
                    <Text
                      color="gray.300"
                      fontSize="md"
                      mb={3}
                      lineHeight="tall"
                    >
                      Proponiamo percorsi individuali di supporto psicologico,
                      pensati per accompagnarti in un percorso di crescita e
                      benessere personale.
                    </Text>
                    <Text
                      color="gray.300"
                      fontSize="md"
                      mb={3}
                      lineHeight="tall"
                    >
                      Emozioni, sensazioni e relazioni sono risorse preziose. In
                      un ambiente accogliente e non giudicante, con il supporto
                      di psicologi qualificati, potrai imparare a conoscerti
                      meglio e a stare più in equilibrio con te stesso e con gli
                      altri.
                    </Text>
                    <Text color="gray.300" fontSize="md" lineHeight="tall">
                      Uno spazio sicuro dove parlare liberamente di ciò che stai
                      vivendo, sviluppare maggiore consapevolezza e trovare
                      nuove risorse per affrontare le difficoltà quotidiane.
                    </Text>
                  </Box>

                  {/* Informazioni Dettagliate */}
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mt={4}>
                    <Box>
                      <Badge
                        colorScheme="yellow"
                        fontSize="sm"
                        mb={2}
                        px={3}
                        py={1}
                        borderRadius="full"
                        w="fit-content"
                      >
                        A chi è rivolto
                      </Badge>
                      <Text color="gray.300" fontSize="md">
                        Persone maggiorenni
                      </Text>
                    </Box>

                    <Box>
                      <Badge
                        colorScheme="blue"
                        fontSize="sm"
                        mb={2}
                        px={3}
                        py={1}
                        borderRadius="full"
                        w="fit-content"
                      >
                        Dove
                      </Badge>
                      <Text color="gray.300" fontSize="md">
                        Spazio di Ascolto e Consulenza Psicologica
                        <br />
                        Via Roma, 12 – Castelnuovo Don Bosco
                        <br />
                        <Text as="span" fontSize="sm" color="gray.400">
                          (presso gli spazi del Comune)
                        </Text>
                      </Text>
                    </Box>

                    <Box>
                      <Badge
                        colorScheme="green"
                        fontSize="sm"
                        mb={2}
                        px={3}
                        py={1}
                        borderRadius="full"
                        w="fit-content"
                      >
                        Quando
                      </Badge>
                      <Text color="gray.300" fontSize="md">
                        Su appuntamento
                      </Text>
                    </Box>

                    <Box>
                      <Badge
                        colorScheme="purple"
                        fontSize="sm"
                        mb={2}
                        px={3}
                        py={1}
                        borderRadius="full"
                        w="fit-content"
                      >
                        Costo
                      </Badge>
                      <Text
                        color="gray.300"
                        fontSize="md"
                        fontWeight="semibold"
                      >
                        Percorso di 8 sedute – 30 € a seduta
                      </Text>
                    </Box>
                  </SimpleGrid>

                  {/* Contatti */}
                  <Box
                    mt={4}
                    p={6}
                    bg="#2f3136"
                    borderRadius="6px"
                    border="1px solid"
                    borderColor="gray.600"
                  >
                    <Heading as="h4" size="md" color="#ffcc00" mb={4}>
                      📩 Contattaci per informazioni o per fissare un
                      appuntamento:
                    </Heading>
                    <VStack spacing={3} align="stretch">
                      <HStack>
                        <EmailIcon color="#ffcc00" />
                        <Link
                          href="mailto:psiturnandre@gmail.com"
                          color="#ffcc00"
                          fontSize="md"
                          fontWeight="medium"
                          _hover={{ textDecoration: 'underline' }}
                          isExternal
                        >
                          psiturnandre@gmail.com
                        </Link>
                      </HStack>
                      <HStack>
                        <PhoneIcon color="#ffcc00" />
                        <Link
                          href="tel:+393490624865"
                          color="#ffcc00"
                          fontSize="md"
                          fontWeight="medium"
                          _hover={{ textDecoration: 'underline' }}
                        >
                          349 062 4865 – Alessandro
                        </Link>
                      </HStack>
                      <HStack>
                        <Text fontSize="md">📘</Text>
                        <Link
                          href="https://www.facebook.com/turnandre"
                          color="#ffcc00"
                          fontSize="md"
                          fontWeight="medium"
                          _hover={{ textDecoration: 'underline' }}
                          isExternal
                        >
                          Facebook: Turnandrè
                        </Link>
                      </HStack>
                    </VStack>
                  </Box>
                </VStack>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>

          {/* IMMAGINE */}
          <Image
            src={turnandreGroup}
            alt="Foto del gruppo Turnandrè"
            borderRadius="md"
            shadow="md"
            w="100%"
            maxH="400px"
            objectFit="cover"
            mb={8}
          />

          {/* SPONSOR */}
          <Box textAlign="center">
            <Text fontSize="md" color="gray.300" mb={2}>
              Un progetto sostenuto da:
            </Text>
            <HStack justify="center">
              <Image
                src={sanpaoloLogo}
                alt="Logo Compagnia di San Paolo"
                height="60px"
                objectFit="contain"
              />
            </HStack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Turnandre;
